import CityAutocomplete from "./CityAutocomplete";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import "./Enquiry.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import airport from "../assets/sis.png";
import authStore from "../services/authStore";
import ScanCard from "./ScanCard";
import ScanQr from "./ScanQr";
export default function Enquiry() {
  const navigate = useNavigate();
  const [cameraMode, setCameraMode] = useState("environment");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [events, setEvents] = useState([]);
  const uploadInputRef = useRef(null);

  const [capturedPhotos, setCapturedPhotos] = useState(Array(5).fill(null));
  const [activeSlot, setActiveSlot] = useState(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [showScanCard, setShowScanCard] = useState(false);
  const [ocrLoading, setOcrLoading] = useState(false);
  const [ocrResult, setOcrResult] =
    useState(null);

  const [showQrScanner, setShowQrScanner] = useState(false);

  const CATEGORIES = [
    { key: "Cleaning", label: "Cleaning" },
    { key: "Delivery", label: "Delivery" },
    { key: "Greeting", label: "Greeting" },
    { key: "FS", label: "Facade/Solar" },
    { key: "iWorkkz", label: "iWorkkz" },
    { key: "All", label: "All" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
  });

  const [categoryChecks, setCategoryChecks] = useState(
    CATEGORIES.reduce((acc, c) => ({ ...acc, [c.key]: false }), {}),
  );

  const [purposeChecks, setPurposeChecks] = useState({
    demo: false,
    sales: false,
    genral: false,
  });

  const [city, setCity] = useState("");
  const [resetKey, setResetKey] = useState(0);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const videoRef = useRef(null);
  const streamRef = useRef(null);

  // const API_BASE_URL = "https://prodapi.iworkkz.com:9095";
  // const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const dataUrlToBase64 = (dataUrl) =>
    dataUrl ? (dataUrl.split(",")[1] ?? null) : null;

  // PURPOSE
  const onPurposeChange = (e) => {
    const { name, checked } = e.target;
    setPurposeChecks((prev) => ({ ...prev, [name]: checked }));
  };
  const PURPOSE_LABELS = { sales: "Sales", genral: "General", demo: "Demo" };

  // handler (no change required but kept for clarity)
  const onCategoryChange = (e) => {
    const { name, checked } = e.target;
    if (name === "All") {
      // when All toggled keep All explicit; other checkboxes stay disabled when All is true
      setCategoryChecks((prev) =>
        Object.keys(prev).reduce((acc, k) => {
          acc[k] = k === "All" ? checked : false;
          return acc;
        }, {}),
      );
    } else {
      setCategoryChecks((prev) => ({
        ...prev,
        [name]: checked,
        All: checked ? false : prev.All,
      }));
    }
  };


  const uploadAndScanCard = async (e) => {
    try {
      const file = e.target.files?.[0];

      if (!file) return;

      setOcrLoading(true); // SHOW LOADER

      const token = authStore.getToken();

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        `${API_BASE_URL}/business-card/scan-card`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      console.log("UPLOAD OCR:", data);

      setOcrResult(data);
    } catch (err) {
      console.error(err);
      toast.error("Card upload failed");
    } finally {
      setOcrLoading(false); // HIDE LOADER
      e.target.value = "";
    }
  };
  // CAMERA
  const openCamera = async (slotIndex) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: cameraMode },
      });
      streamRef.current = stream;
      setActiveSlot(slotIndex);
      setCameraOpen(true);
      setTimeout(() => {
        if (videoRef.current) videoRef.current.srcObject = stream;
      }, 100);
    } catch (err) {
      toast.error("Camera access denied or unavailable");
    }
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    if (!video) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    const imageData = canvas.toDataURL("image/jpeg");

    setCapturedPhotos((prev) => {
      const updated = [...prev];
      updated[activeSlot] = imageData;
      return updated;
    });

    streamRef.current?.getTracks().forEach((t) => t.stop());
    setCameraOpen(false);
    setActiveSlot(null);
  };

  const retakePhoto = (index) => {
    setCapturedPhotos((prev) => {
      const updated = [...prev];
      updated[index] = null;
      return updated;
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const form = e.currentTarget;

    const selectedPurposesArray = Object.entries(purposeChecks)
      .filter(([, v]) => v)
      .map(([k]) => PURPOSE_LABELS[k] || k);

    if (selectedPurposesArray.length === 0) {
      toast.error("Select at least one purpose.");
      return;
    }

    const phone = `+91${formData.phone.trim()}`;

    if (!/^\+91[0-9]{10}$/.test(phone)) {
      toast.error("Invalid mobile number.");
      return;
    }

    if (!city.trim()) {
      toast.error("City is required.");
      return;
    }

    const anyCategorySelected =
      categoryChecks.All ||
      Object.entries(categoryChecks).some(
        ([key, value]) => value === true && key !== "All",
      );

    if (!anyCategorySelected) {
      toast.error("Select at least one category.");
      return;
    }

    const categories = categoryChecks.All
      ? Object.keys(categoryChecks).filter((k) => k !== "All")
      : Object.entries(categoryChecks)
        .filter(([k, v]) => v && k !== "All")
        .map(([k]) => k);

    try {
      setIsSubmitting(true);

      const submitData = new FormData();

      submitData.append("eventid", Number(selectedEvent));
      submitData.append("name", form.name.value.trim());
      submitData.append("companyname", form.company.value.trim());
      submitData.append("mobileno", phone);
      submitData.append("emailid", form.email.value.trim());

      submitData.append("city", city.trim());
      submitData.append("state", "");
      submitData.append("country", "India");
      submitData.append("website", "");

      submitData.append("purpose", selectedPurposesArray.join(","));
      submitData.append("category", categories.join(","));

      submitData.append("remarks", form.message.value.trim());

      submitData.append("createdby", "1");

      // Convert Base64 to Blob and attach
      capturedPhotos.forEach((photo, index) => {
        if (photo) {
          const byteString = atob(photo.split(",")[1]);

          const mimeString = photo.split(",")[0].split(":")[1].split(";")[0];

          const ab = new ArrayBuffer(byteString.length);

          const ia = new Uint8Array(ab);

          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([ab], { type: mimeString });

          submitData.append(
            `attachment${index + 1}`,
            blob,
            `photo${index + 1}.jpg`,
          );
        }
      });

      const token = authStore.getToken();

      const response = await fetch(`${API_BASE_URL}/enquiry/AddEnquiry`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: submitData,
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.detail || "Submission failed");
      }

      toast.success("Enquiry submitted successfully ✅");

      form.reset();

      setCapturedPhotos(Array(5).fill(null));
      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
      });

      setCity("");

      setResetKey((k) => k + 1);

      setPurposeChecks({
        demo: false,
        sales: false,
        genral: false,
      });

      setCategoryChecks({
        Cleaning: false,
        Delivery: false,
        Greeting: false,
        FS: false,
        iWorkkz: false,
        All: false,
      });
    } catch (err) {
      console.error(err);

      toast.error(err.message || "Submit failed");
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const token = authStore.getToken();

        const response = await fetch(
          `${API_BASE_URL}/event/GetEventList?status=Active`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = await response.json();

        // adjust based on API response structure
        const list = Array.isArray(data) ? data : data?.data || [];

        setEvents(list);
      } catch (err) {
        console.error("Event fetch failed", err);
        toast.error("Failed to load events");
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    if (!ocrResult) return;

    console.log("OCR DATA:", ocrResult);

    setFormData({
      name: ocrResult.name || "",
      company: ocrResult.company_name || "",
      email: ocrResult.email_addresses?.[0] || "",
      phone:
        ocrResult.phone_numbers?.[0]
          ?.replace(/\s/g, "")
          .replace("+91", "") || "",
    });

    setShowScanCard(false);

  }, [ocrResult]);


  return (




    <div className="EnquiryContainer">

      {showScanCard && (
        <ScanCard
          setResult={(data) => {
            console.log("OCR Result:", data);
            setOcrResult(data);
          }}
          onClose={() => setShowScanCard(false)}
          setOcrLoading={setOcrLoading}
        />
      )}

      

      {showQrScanner && (
        <ScanQr
          onClose={() => setShowQrScanner(false)}
          setOcrLoading={setOcrLoading}
          onScanSuccess={(data) => {
            console.log("QR DATA:", data);

            setFormData((prev) => ({
              ...prev,
              name: data.name || "",
              company: data.company || "",
              email: data.email || "",
              phone:
                data.phones?.[0]
                  ?.replace(/\D/g, "")
                  .slice(-10) || "",
            }));

            setShowQrScanner(false);
          }}
        />
      )}


      <input
        ref={uploadInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={uploadAndScanCard}
      />

      <div className="enquiry-header">
        <div className="top-action-buttons">

          <button
            type="button"
            className="top-btn"
            onClick={() => setShowScanCard(true)}
          >
            Scan Card
          </button>

          <button
            type="button"
            className="top-btn"
            onClick={() => setShowQrScanner(true)}
          >
            Scan QR
          </button>

          <button
            type="button"
            className="top-btn"
            onClick={() => uploadInputRef.current?.click()}
          >
            Upload Card
          </button>

        </div>
      </div>
      <form onSubmit={onSubmit} noValidate>
        {/* disable native controls during submit */}
        <fieldset disabled={isSubmitting} aria-busy={isSubmitting}>
          

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <select
              className="form-select mb-3 mt-3"
              value={selectedEvent}
              onChange={(e) => setSelectedEvent(e.target.value)}
              required
            >
              <option value="" disabled>
                Select an event
              </option>

              {events.map((ev) => (
                <option key={ev.id || ev.eventid} value={ev.id || ev.eventid}>
                  {ev.name || ev.eventname}
                </option>
              ))}
            </select>

            {/* Static Logo */}
            {/* <img
              src={airport} // your static logo path
              alt="logo"
              style={{ width: "100px", height: "100px", objectFit: "contain" }}
            /> */}
          </div>

          {/* NAME */}
          <input
            name="name"
            type="text"
            className="form-control mb-3"
            placeholder="Your Name"
            value={formData.name}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: e.target.value,
              })
            }
            required
          />

          {/* COMPANY */}
          <input
            name="company"
            type="text"
            className="form-control mb-3"
            placeholder="Your Company"
            value={formData.company}
            onChange={(e) =>
              setFormData({
                ...formData,
                company: e.target.value,
              })
            }
            required
          />

          {/* CITY */}
          <div className="mb-3">
            <CityAutocomplete
              key={resetKey}
              name="city"
              value={city}
              onChange={(val) => setCity(val || "")}
              onSelect={(opt) => setCity(opt?.label || opt || "")}
            />
          </div>

          {/* EMAIL */}
          <input
            name="email"
            type="email"
            className="form-control mb-3"
            placeholder="you@company.com"
            value={formData.email}
            onChange={(e) =>
              setFormData({
                ...formData,
                email: e.target.value,
              })
            }
            required
          />

          {/* PHONE */}
          <PhoneInput
            country={"in"}
            enableSearch={true}
            value={formData.phone}
            onChange={(phone) =>
              setFormData({
                ...formData,
                phone,
              })
            }
            inputStyle={{
              width: "100%",
              height: "55px",
            }}
            containerStyle={{
              marginBottom: "1rem",
            }}
          />

          {/* PURPOSE */}
          <label className="form-label d-block">Purpose</label>
          <div className="row mb-3">
            {[
              { name: "sales", label: "Sales" },
              { name: "genral", label: "General" },
              { name: "demo", label: "Demo" },
            ].map(({ name, label }) => {
              const id = `chk-${name}`;
              return (
                <div className="col-4" key={name}>
                  <label
                    htmlFor={id}
                    className="form-check-label d-flex align-items-center"
                  >
                    <input
                      id={id}
                      className="form-check-input me-2"
                      type="checkbox"
                      name={name}
                      checked={purposeChecks[name]}
                      onChange={onPurposeChange}
                    />
                    {label}
                  </label>
                </div>
              );
            })}
          </div>

          {/* CATEGORY */}
          <label className="form-label d-block">Category</label>
          <div className="row mb-3">
            {CATEGORIES.map((cat) => {
              const id = `cat-${cat.key.replace(/\W+/g, "")}`;
              return (
                <div className="col-4" key={cat.key}>
                  <label
                    htmlFor={id}
                    className="form-check-label d-flex align-items-center"
                  >
                    <input
                      id={id}
                      className="form-check-input me-2"
                      type="checkbox"
                      name={cat.key}
                      checked={!!categoryChecks[cat.key]}
                      onChange={onCategoryChange}
                      disabled={categoryChecks.All && cat.key !== "All"}
                    />
                    {cat.label}
                  </label>
                </div>
              );
            })}
          </div>

          {/* MESSAGE */}
          <textarea
            name="message"
            className="form-control mb-3"
            rows={2}
            placeholder="Tell us about your needs..."
            required
          />

          {/* PHOTO GRID */}
          <div
            className="photo-grid mb-3"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "10px",
            }}
          >
            {capturedPhotos.map((photo, index) => (
              <div
                key={index}
                style={{
                  border: "2px dashed #999",
                  borderRadius: 8,
                  aspectRatio: "1 / 1",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#f8f9fa",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
                onClick={() => (photo ? retakePhoto(index) : openCamera(index))}
              >
                {photo ? (
                  <img
                    src={photo}
                    alt={`Captured ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <span className="text-muted">+</span>
                )}
              </div>
            ))}
          </div>

          {/* SUBMIT */}
          <button
            type="submit"
            className="btn btn-dark w-100 btn-lg"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </fieldset>
      </form>

      {/* CAMERA OVERLAY */}
      {cameraOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#000",
            zIndex: 9999,
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />




          {/* SWITCH CAMERA */}
          <button
            onClick={() => {
              streamRef.current?.getTracks().forEach((t) => t.stop());
              setCameraMode((prev) => {
                const next = prev === "environment" ? "user" : "environment";
                setTimeout(() => openCamera(activeSlot), 50);
                return next;
              });
            }}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.8)",
              border: "3px solid #ccc",
              fontSize: 24,
            }}
          >
            🔄
          </button>

          {/* CAPTURE BUTTON */}
          <button
            onClick={capturePhoto}
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              bottom: 40,
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "#fff",
              border: "4px solid #ddd",
            }}
          >
            📸
          </button>




        </div>
      )}

      {ocrLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 10001,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            gap: "12px",
          }}
        >
          <div
            className="spinner-border"
            role="status"
          />

          <div>
            Scanning Business Card...
          </div>
        </div>
      )}

      {/* SUBMITTING OVERLAY */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div className="spinner-border" role="status" aria-hidden="true" />
          <div>Submitting... Please wait</div>
        </div>
      )}
    </div>
  );
}
